<template>
  <el-select class="counters-select-cameras" v-model="model" :placeholder="$tf('not_selected')" multiple>
    <el-option v-for="item of cameras" :key="item.id" :label="item.name" :value="item.id">
      <el-tooltip effect="dark" :content="item.name" placement="top">
        <span>{{ item.name | shortString }}</span>
      </el-tooltip>
    </el-option>
  </el-select>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: {
    value: { type: Array, required: true },
    items: { type: Array, required: true },
    groups: { type: Array, required: true }
  }
})
export default class CountersSelectCameras extends Vue {
  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get cameras() {
    return this.items.filter(({ group }) => this.groups.includes(group));
  }
}
</script>

<style lang="stylus">
.counters-select-cameras {
  width: 20rem;
}
</style>
